import type { Backlink, Link } from '@pique/core/modules/doc-link';

import { PiquePageReference } from '../../reference-link';
import { useManager } from '../common';
import * as styles from './links-row.css';

export const LinksRow = ({
  references,
  label,
  className,
  onClick,
}: {
  references: Backlink[] | Link[];
  label: string;
  className?: string;
  onClick?: () => void;
}) => {
  const manager = useManager();
  return (
    <div className={className}>
      <div className={styles.title}>
        {label} · {references.length}
      </div>
      {references.map(link => (
        <PiquePageReference
          key={link.docId}
          pageId={link.docId}
          wrapper={props => (
            <div className={styles.wrapper} onClick={onClick} {...props} />
          )}
          docCollection={manager.workspace.docCollection}
        />
      ))}
    </div>
  );
};
